import PropTypes from 'prop-types';
import React from 'react';

import styled from 'styled-components';
import { colors } from '../../styles/colors';

import { Tooltip } from '../Tooltip/Tooltip';

const IconSpacer = styled.div`
  display: flex;
  align-items: center;
  margin-top: ${(props) => `${props.mt}rem` || '0'};
  margin-right: ${(props) => `${props.mr}rem` || '0'};
  margin-bottom: ${(props) => `${props.mb}rem` || '0'};
  margin-left: ${(props) => `${props.ml}rem` || '0'};
`;

const StyledButton = styled.button`
  border: none;
  background: transparent;
`;

const StyledDisabledSpacer = styled.div`
  // To match the button spacing on non disabled icons
  padding: 1px 6px;
  fill: ${colors['gray']['5']};
`;

/**
 * Primary UI component for user interaction
 */
const IconButton = ({
  src,
  disabledSrc,
  iconSvg,
  disabled,
  alt,
  mt,
  mr,
  mb,
  ml,
  width,
  height,
  onClick,
  tooltipText,
  tooltipPlacement,
  isMobile,
  ...props
}) => {
  let iconBody = (
    <StyledButton type="button" onClick={onClick}>
      {iconSvg}
    </StyledButton>
  );

  if (disabled) {
    iconBody = <StyledDisabledSpacer>{iconSvg}</StyledDisabledSpacer>;
  }

  return (
    <IconSpacer mt={mt} mr={mr} mb={mb} ml={ml}>
      {!!tooltipText ? (
        <Tooltip title={tooltipText} placement={tooltipPlacement} isMobile={isMobile}>
          <div>{iconBody}</div>
        </Tooltip>
      ) : (
        <React.Fragment>{iconBody}</React.Fragment>
      )}
    </IconSpacer>
  );
};

IconButton.propTypes = {
  src: PropTypes.string,

  disabledSrc: PropTypes.string,

  disabled: PropTypes.bool,

  alt: PropTypes.string,

  mt: PropTypes.number,

  mr: PropTypes.number,

  mb: PropTypes.number,

  ml: PropTypes.number,

  width: PropTypes.number,

  height: PropTypes.number,

  onClick: PropTypes.func,

  tooltipText: PropTypes.string,

  tooltipPlacement: PropTypes.oneOf([
    'top',
    'left',
    'right',
    'bottom',
    'topLeft',
    'topRight',
    'bottomLeft',
    'bottomRight',
    'leftTop',
    'leftBottom',
    'rightTop',
    'rightBottom',
  ]),

  isMobile: PropTypes.bool,
};

export { IconButton };
